import variables from '../styles/_variables.module.scss';

// parse SASS variables and convert rem to px: "1rem" -> 16
export const XS = 16 * parseFloat(variables.breakpoint_xs);
export const SM = 16 * parseFloat(variables.breakpoint_sm);
export const MD = 16 * parseFloat(variables.breakpoint_md);
export const LG = 16 * parseFloat(variables.breakpoint_lg);
export const XL = 16 * parseFloat(variables.breakpoint_xl);
